__webpack_require__.p = "https://stage-ru3.myqg.ru/";